import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = process.env.VITE_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com';

let ready = false;

export const initAnalytics = () => {
  if (ready || !POSTHOG_KEY) return;
  try {
    posthog.init(POSTHOG_KEY, { api_host: POSTHOG_HOST, capture_pageview: true, persistence: 'localStorage', autocapture: false });
    ready = true;
  } catch (e) {
    console.warn('PostHog initialization failed:', e);
  }
};

export const trackEvent = (eventName, properties) => {
  if (ready) posthog.capture(eventName, properties);
};

